import script from "./cLayout.vue?vue&type=script&lang=js"
export * from "./cLayout.vue?vue&type=script&lang=js"

import "./cLayout.vue?vue&type=style&index=0&id=2de3c122&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de3c122"],['__file',"src/components/cmp/cLayout/cLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2de3c122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2de3c122', __exports__)) {
    api.reload('2de3c122', __exports__)
  }
  
}


export default __exports__